export const environment = {
  production: false,
  staging: true,
  apiUrl: 'https://api-staging.routini.at',
  keycloak: {
    url: 'https://auth-staging.routini.at',
    realm: 'routini',
    clientId: 'management-dashboard',
    urlPattern: /^(https:\/\/api-staging.routini.at)(\/.*)?$/i,
    sessionTimeout: 300000,
    authUrl:
      'https://auth-staging.routini.at/realms/routini/protocol/openid-connect/auth?response_type=code&client_id=management-dashboard&redirect_uri=https://management-staging.routini.at/home',
  },
  googleMapsApiKey: 'AIzaSyDn_AQJEGiY2eFNTFFiNGlfQaC9pf_W938',
  googleMapId: 'G-7PEXJTTC72',
  clairityId: 'v7g2b1jxjf',
};
